import { IconFire, IconSparkles, IconCheck } from './icons';
import './StreakWidget.css';

interface StreakWidgetProps {
  streakDays: number;
}

const DAY_NAMES = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

export function StreakWidget({ streakDays }: StreakWidgetProps) {
  const today = new Date();
  const dayOfWeek = today.getDay(); // 0 = Sun
  // Normalise: 0 = Mon, 6 = Sun
  const normalizedToday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

  return (
    <div className="streak-widget">
      <div className="streak-header">
        <span className="streak-fire" aria-hidden><IconFire size={18} /></span>
        <span className="streak-title">
          Серия: {streakDays} {getDayWord(streakDays)}
        </span>
      </div>
      <div className="streak-days">
        {DAY_NAMES.map((name, i) => {
          const daysAgo = normalizedToday - i;
          const isChecked = daysAgo >= 0 && daysAgo < streakDays;
          const isToday = i === normalizedToday;
          return (
            <div
              key={name}
              className={`streak-day${isChecked ? ' checked' : ''}${isToday ? ' today' : ''}`}
            >
              <span className="streak-day-name">{name}</span>
              <span className="streak-day-icon">{isChecked ? <IconCheck size={10} /> : null}</span>
            </div>
          );
        })}
      </div>
      {streakDays >= 3 && (
        <div className="streak-bonus"><IconSparkles size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} /> Бонус: проекты выше в каталоге</div>
      )}
    </div>
  );
}

function getDayWord(n: number): string {
  const abs = Math.abs(n) % 100;
  const last = abs % 10;
  if (abs >= 11 && abs <= 19) return 'дней';
  if (last === 1) return 'день';
  if (last >= 2 && last <= 4) return 'дня';
  return 'дней';
}
